<template>
  <div class="login-auto">

  </div>
</template>

<script>
export default {
  name: "loginAuto",
  data() {
    return {
      loginName: '',
      secretKey: '',
      appid: '',
      timestamp: '',
      loading: null,
    }
  },
  async mounted() {
    this.loginName = this.$route.query.loginName;
    this.secretKey = this.$route.query.secretKey;
    this.appid = this.$route.query.appid;
    this.timestamp = this.$route.query.timestamp;
    this.loading = this.$loading({
      lock: true,
      text: '加载中，请稍后...',
      spinner: 'el-icon-loading',
      // background: 'rgba(0, 0, 0, 0.7)'
    });
    if (!this.loginName || !this.secretKey) {
      setTimeout(() => {
        this.loading.close();
        this.$router.push({ name: 'home' })
      }, 1000)
    } else {
      await this.loginBySecretKey();
    }
  },
  methods: {
    async getSecretKey() {
      const {resultCode,result} = await this.catReq1Service("/user/getSecretKey", {
        loginPhone: this.loginName,
        secret: "",
      })
    },
    async loginBySecretKey() {
      let param = {
        loginName: this.loginName,
        secretKey: this.secretKey,
        appId: this.appid,
        timestamp: this.timestamp
      }
      const { resultCode, result } = await this.catReq1Service("/user/loginBySecretKeyPlus",param);
      if (resultCode === '1') {
        this.loading.close();
        this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-auto {
}
</style>